// extracted by mini-css-extract-plugin
export default {"frontEnd":"MySkills_frontEnd__3KdUU"};